import React from 'react';
import Slider from 'react-styled-carousel';
import styled, { css } from 'styled-components';

import { zIndexFor } from '../styles/utilities';
import Tile from './tile';

const Root = styled.div`
  border: 1px solid ${props => props.theme.color.gray92};
  box-shadow: ${props => props.theme.shadow.standard};
  margin-top: 40px;
  position: relative;
  width: calc(100vw - 40px);

  ul {
    margin-bottom: -6px;
  }
`;

const CarouselTile = styled(Tile)`
  && {
    height: 344px;
    padding-bottom: 88px;

    ${props =>
      props.image
        ? css`
          background-image: linear-gradient(40deg, white 55%, rgba(255,255,255,0.45)), url('${
            props.image
          }');
          background-size: cover;
      `
        : ''};
  }
`;

const arrowStyles = `
  align-items: center;
  background: none;
  border: none;
  bottom: 28px;
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: center;
  padding: 0;
  position: absolute;
  width: 44px;
  z-index: ${zIndexFor('TileSlider')};
`;

const LeftArrow = styled.button`
  ${arrowStyles} left: 24px;
  transform: rotate(180deg);
`;

const RightArrow = styled.button`
  ${arrowStyles} right: 24px;
`;

const Chevron = styled.img`
  transform: rotate(90deg);
`;

export default ({ tiles, className }) => {
  return (
    <Root className={className}>
      <Slider
        autoSlide={false}
        cardsToShow={1}
        padding="0"
        showDots={false}
        LeftArrow={
          <LeftArrow>
            <Chevron src="images/chevron.svg" width="16" height="8" />
          </LeftArrow>
        }
        RightArrow={
          <RightArrow>
            <Chevron src="images/chevron.svg" width="16" height="8" />
          </RightArrow>
        }
      >
        {tiles.map(tile => (
          <CarouselTile
            key={tile.title}
            title={tile.title}
            description={tile.description}
            linkText={tile.linkText}
            linkTarget={tile.linkTarget}
            image={tile.backgroundImage}
          />
        ))}
      </Slider>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/components/tileSlider.js